<template>
  <BaseModal
    @onClose="MainStore.pwModal.show = false"
    :btnText="message.common.modal.close[language]"
    :width="400"
    :padding="CommonStore.isMobile ? '2.4rem 0' : '32px 0'"
  >
    <template v-slot:modalContent>
      <div :class="tStyle.modalWrap">
        <h3 :class="tStyle.title">{{ message.myPage.auth.title[language] }}</h3>
        <p :class="tStyle.title2">{{ message.myPage.auth.title2[language] }}</p>
        <div class="relative flex items-center mt-[32px]">
          <input
            :type="pwView ? 'text' : 'password'"
            :placeholder="message.myPage.auth.pwInput[language]"
            :class="tStyle.input"
            v-model="password"
          />
          <img
            :src="require(`@/assets/${pwView ? 'invisible' : 'visible'}.png`)"
            alt=""
            class="absolute w-8 cursor-pointer right-4 opacity-70"
            @click="pwView = !pwView"
          />
        </div>
      </div>
    </template>
    <template v-slot:addBtn>
      <button :class="tStyle.addrBtn" @click="goMyPage">
        {{ message.myPage.auth.move[language] }}
      </button>
    </template>
  </BaseModal>
</template>
<script setup>
import { reactive, ref, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import BaseModal from '@/feature/common/components/BaseModal.vue';
import { login } from '@/apis/auth';
import useAuthStore from '@/store/auth';

import { rootStore } from '@/store/rootStore';
const CommonStore = reactive(rootStore?.commonStore());
const MainStore = reactive(rootStore?.mainStore());
const authStore = useAuthStore();

const { language, message } = defineProps({
  language: String,
  message: Object
});

const router = useRouter();

const password = ref('');

const pwView = ref(false);

const goMyPage = async () => {
  const params = {
    loginId: authStore.userInfo?.value.loginId,
    password: password.value
  };
  try {
    const result = await login(params);
    if (result.status === 201) {
      authStore.login.value(result.data);
      router.push('/mypage');
      authStore.authInfo.value.myPage = 'ok';
      MainStore.pwModal.show = false;
    }
  } catch (error) {
    console.error('mypage password check error :', error);
  }
};

const tStyle = ref({
  modalWrap: 'text-left px-[24px] pc:pb-[32px] mobile:pb-[2.4rem] text-center',
  title: 'text-[20px] font-semibold tracking-[-0.48px] mobile:text-[1.6rem]',
  title2:
    'text-[#646464] text-[20px] font-medium tracking-[-0.4px] mt-[16px] mobile:text-[1.4rem]',
  input:
    'px-[16px] pt-[15px] pb-[14px]  rounded-[4px] border border-[#CFCFCF] w-full mobile:text-[1.4rem] placeholder:text-[#999]',
  addrBtn:
    'text-[#fff] rounded-[4px] bg-key py-[9px] w-[132px] disabled:bg-dis mobile:basis-1/2'
});
</script>
